import { ProjectIcon } from "./ProjectIcon";
import { GitBranchIcon, ServerIcon, CpuIcon } from "lucide-react";

export function SidebarThreadDetails({
  title,
  project,
  projectIcon,
  environment,
  branch,
  model,
}: {
  title: string;
  project: string;
  projectIcon?: string | undefined;
  environment: string;
  branch: string | null;
  model: string;
}) {
  return (
    <div className="grid gap-2 text-xs">
      <div className="font-medium text-foreground">{title}</div>
      <div className="grid gap-1.5 text-muted-foreground">
        <div className="flex items-center gap-2">
          <ProjectIcon icon={projectIcon} className="size-3" />
          {project}
        </div>
        <div className="flex items-center gap-2">
          <ServerIcon className="size-3" />
          {environment}
        </div>
        {branch ? (
          <div className="flex items-center gap-2">
            <GitBranchIcon className="size-3" />
            {branch}
          </div>
        ) : null}
        <div className="flex items-center gap-2">
          <CpuIcon className="size-3" />
          {model}
        </div>
      </div>
    </div>
  );
}
